import { createReducer } from 'deox';
import { uiActions } from '../actions';

export enum Device {
  mobile = 'mobile',
  desktop = 'desktop',
}

export interface UIState {
  device: {
    type: string;
    width: number;
  };
  coordinates: {
    pathname: string;
    x: number;
    y: number;
  }[];
  selectedGroupApiHome: {
    name: string;
    coordinate: {
      x: number;
      y: number;
    };
  };
  inViewport: {
    bankApiFooterInViewport: boolean;
  };
}

const initialState: UIState = {
  device: {
    type: window.innerWidth > 768 ? Device.desktop : Device.mobile,
    width: window.innerWidth,
  },
  coordinates: [
    {
      pathname: '/apis',
      x: 0,
      y: 0,
    },
  ],
  selectedGroupApiHome: {
    name: '',
    coordinate: {
      x: 0,
      y: 0,
    },
  },
  inViewport: {
    bankApiFooterInViewport: false,
  },
};

const uiReducer = createReducer(initialState, (handleAction) => [
  handleAction(uiActions.setDevice, (state, { payload }) => {
    return {
      ...state,
      device: {
        type: payload.deviceWidth > 768 ? Device.desktop : Device.mobile,
        width: payload.deviceWidth,
      },
    };
  }),
  handleAction(uiActions.persistCoordinate, (state, { payload }) => {
    const { pathname, coordinate } = payload;
    const newCoordinate = state.coordinates.map((page) =>
      page.pathname === pathname ? { ...page, x: coordinate.x, y: coordinate.y } : page,
    );
    return {
      ...state,
      coordinates: newCoordinate,
    };
  }),
  handleAction(uiActions.persistSelectedGroupApiHome, (state, { payload }) => {
    const { name, coordinate } = payload;
    const newSelectedGroupApiHome = { name, coordinate };
    return {
      ...state,
      selectedGroupApiHome: newSelectedGroupApiHome,
    };
  }),
  handleAction(uiActions.setBankApiFooterInViewport, (state, { payload }) => {
    const { footerInViewport } = payload;
    const newViewport = { ...state.inViewport, bankApiFooterInViewport: footerInViewport };
    return {
      ...state,
      inViewport: newViewport,
    };
  }),
]);

export default uiReducer;
